import ThreeCanvas from './ThreeCanvas';
import useThreeNudgytAgentCoreClient from '../../hooks/useThreeNudgytAgentCoreClient';

/**
 * Nudgyt Agent client for Basic + Nudgyt Core on a 3JS avatar.
 * Mounted outside <Canvas> so the websocket stays alive when the iframe is hidden.
 */
function ThreeNudgytAgentCoreClient() {
  const { client } = useThreeNudgytAgentCoreClient();

  return <ThreeCanvas client={client} />;
}

export default ThreeNudgytAgentCoreClient;
